export const PIXELS_PER_MM = 11.811023622047244 // At 300 DPI

export const BLEED = 3.18 * PIXELS_PER_MM
export const HALF_BLEED = BLEED / 2
export const MARGIN = 12.7 * PIXELS_PER_MM
export const SPINE_MARGIN = 3.175 * PIXELS_PER_MM

export const VISIBLE_HEIGHT = 2480
export const VISIBLE_WIDTH = 1748

// Total height in pixels (A5 + bleed) = 2517

// A5: 210 x 148 mm
// Bleed: 3.18 mm
export const HEIGHT_IN_PX_WITH_BLEED = VISIBLE_HEIGHT + BLEED * 2
export const WIDTH_WITH_BLEED_PX = VISIBLE_WIDTH + BLEED // No bleed on spine side of page.
